(function () {
  // Backup JS guard for browsers where overscroll-behavior-x: none is insufficient.
  // Prevents back/forward navigation only at carousel edges — native scroll handles
  // everything else.
  function attach(el) {
    if (el.dataset.swipeFix) return;
    el.dataset.swipeFix = '1';
    el.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;
      var goingLeft   = e.deltaX < 0;
      var atLeftEdge  = el.scrollLeft <= 1;
      var atRightEdge = el.scrollLeft >= el.scrollWidth - el.clientWidth - 1;
      if ((goingLeft && atLeftEdge) || (!goingLeft && atRightEdge)) {
        e.preventDefault();
      }
    }, { passive: false });
  }

  function attachAll() {
    document.querySelectorAll('.scroll-area, .sw-cfp__thumbs, .sw-ed__thumbs').forEach(attach);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachAll);
  } else {
    attachAll();
  }

  document.addEventListener('shopify:section:load', attachAll);
})();

// Disable mobile menu stagger regardless of theme setting
if (window.themeVariables && window.themeVariables.settings) {
  window.themeVariables.settings.staggerMenuApparition = false;
}

// Size slideshow section to screen.height - announcement bar height (= Chrome-hidden viewport).
// CSS lvh resolves incorrectly on this device, so JS measurement is the reliable path.
(function () {
  function fixSlideshowHeight() {
    var el = document.querySelector('.shopify-section--slideshow');
    if (!el) return;
    // SW: wider than a portrait phone (for example after rotating to landscape) the CSS height applies again
    if (window.innerWidth > 699) { el.style.removeProperty('height'); return; }
    // SW: measure the bar itself; the CSS variable can lag one frame behind after rotation
    var barEl = document.querySelector('.shopify-section--announcement-bar');
    var barH = barEl ? barEl.getBoundingClientRect().height : 0;
    if (!barH) {
      barH = parseFloat(
        getComputedStyle(document.documentElement).getPropertyValue('--announcement-bar-height')
      ) || 0;
    }
    el.style.setProperty('height', (screen.height - 2 * barH) + 'px', 'important');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixSlideshowHeight);
  } else {
    fixSlideshowHeight();
  }
  window.addEventListener('load', fixSlideshowHeight);
  // SW: re-measure as soon as the viewport width changes (rotation); height-only changes (browser bars) are ignored
  var lastW = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastW) return;
    lastW = window.innerWidth;
    fixSlideshowHeight();
  }, { passive: true });
  window.addEventListener('orientationchange', fixSlideshowHeight);
})();

// Prevent Enter in the cart discount input from submitting the cart form (→ checkout).
// Fire a change event instead, which triggers the same Apply logic.
document.addEventListener('keydown', function (e) {
  if (e.key !== 'Enter') return;
  if (!e.target.closest('cart-discount-field')) return;
  if (e.target.type === 'hidden') return;
  e.preventDefault();
  e.target.dispatchEvent(new Event('change', { bubbles: true }));
}, { capture: true });

// Blur page content when Judge.me review modal opens
(function () {
  function blur()   { document.body.classList.add('jdgm-modal-open'); }
  function unblur() { document.body.classList.remove('jdgm-modal-open'); }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.jm-action-buttons__button, .jdgm-write-rev-link, .jdgm-ask-question-btn')) {
      blur();
    } else if (e.target.closest('.jdgm-write-review-modal__close-btn, .jdgm-modal-block__close-button, .jdgm-write-review-modal__nav-btn-close, .jdgm-ask-question-form__actions-button, [class*="modal__close"]')) {
      unblur();
    } else if (e.target.closest('.jdgm-write-review-modal__overlay')) {
      var closeBtn = document.querySelector('.jdgm-write-review-modal__close-btn');
      if (closeBtn) closeBtn.click();
      unblur();
    } else if (e.target.closest('.jdgm-modal__container') && !e.target.closest('.jdgm-modal-block')) {
      var closeBtn = document.querySelector('.jdgm-modal-block__close-button');
      if (closeBtn) closeBtn.click();
      unblur();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') unblur();
  });
})();

// Animate shipping progress bar from its previous position rather than always from zero.
(function () {
  var prevFillPct = '0';

  document.addEventListener('cart:change', function () {
    var fill = document.querySelector('.sw-shipping-progress__fill');
    if (fill) prevFillPct = fill.style.getPropertyValue('--sw-fill') || '0';
  });

  document.addEventListener('cart-drawer:refreshed', function () {
    var fill = document.querySelector('.sw-shipping-progress__fill');
    if (fill) fill.style.setProperty('--sw-fill-from', prevFillPct);
  });
})();

// Fix product sticky bar showing the wrong version on reload at a scrolled position.
// On reload, hide the bar immediately so the IO's wrong state never flashes.
// Poll every frame until scroll is restored, then set the correct state.
(function () {
  var nav = performance.getEntriesByType('navigation')[0];
  if (!nav || nav.type !== 'reload') return;

  var bar = document.querySelector('product-sticky-bar');
  var atcBlock = document.querySelector('[data-block-type="buy-buttons"]');
  if (!bar || !atcBlock) return;

  // Hide before any IO-driven animation can fire
  bar.style.visibility = 'hidden';

  var done = false;
  var deadline = Date.now() + 1500;

  function fix() {
    if (done) return;
    var atcRect = atcBlock.getBoundingClientRect();
    if (atcRect.bottom < 0) {
      bar.classList.remove('sw-above-fold', 'sw-atc-in-view');
      bar.classList.add('is-visible');
      bar.style.transition = 'none';
      bar.style.transform = 'translateY(0)';
      void bar.offsetHeight;
      bar.style.transition = '';
      bar.style.transform = '';
      bar.style.visibility = '';
      done = true;
    } else if (Date.now() < deadline) {
      requestAnimationFrame(fix);
    } else {
      bar.style.visibility = '';
    }
  }

  requestAnimationFrame(fix);
  window.addEventListener('scroll', fix, { once: true, passive: true });
})();

